export enum StickerCreationStage {
    ADD_MEDIA,
    ADD_AUDIO,
    ADD_DETAILS,
    FINISH,
}
